import { render } from "./AboutPageView.vue?vue&type=template&id=42681b4f"
import script from "./AboutPageView.vue?vue&type=script&lang=js"
export * from "./AboutPageView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__